import {
  createContext,
  PropsWithChildren,
  useContext,
  useMemo,
} from 'react';
import { usePageConfiguration } from './usePageConfiguration';
import { ApplicationPageType } from '../../components/AccountTabNav';

export type PageConfigurationContextType = {
  isReadOnly: boolean
}

const defaultPageConfigurationContext: PageConfigurationContextType = {
  isReadOnly: false,
};
export const PageConfigurationContext = createContext(defaultPageConfigurationContext);

export function usePageConfigurationContext() {
  return useContext(PageConfigurationContext);
}

export function PageConfigurationProvider({ children, page }: PropsWithChildren<{ page: ApplicationPageType }>) {
  const pageConfiguration = usePageConfiguration(page);

  const contextValue = useMemo(() => ({ ...pageConfiguration }), [pageConfiguration]);

  return (
    <PageConfigurationContext.Provider value={contextValue}>
      {children}
    </PageConfigurationContext.Provider>
  );
}
